import React, { Component } from 'react';
import { connect } from 'react-redux';

import { generateUnsafeHash, focusAfterTimeout } from '../../util';

import { NumericalInput } from '../shared';

const DEFAULT_STATE = {
  goalName: '',
  goalDescription: '',
  goalTarget: '',
}

class CustomGoalModal extends Component{

  state = DEFAULT_STATE;

  clearState(){
    this.setState(DEFAULT_STATE);
  }

  componentWillMount(){
    this.hide = this.hide.bind(this);
    this.createGoal = this.createGoal.bind(this);
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.visible){
      focusAfterTimeout(this, 'goalNameInput');
    }
  }

  hide(){
    if(!this.props.confirming){
      this.props.hide();
      this.clearState();
    }
  }

  goalType(){
    switch(this.props.category){
      default:
        return 'do';
      case 'behavior':
        return 'do';
      case 'skill':
        return 'do';
      case 'activity':
        return 'measure';
      case 'outcome':
        return 'forecast';
    }
  }

  createGoal(){

    const { goalName, goalDescription, goalTarget } = this.state;

    let newGoal = {
      isCustomGoal: true,
      name: goalName,
      description: goalDescription,
      category: this.props.category,
      goalType: this.goalType(),
      id: generateUnsafeHash()
    }

    if(goalTarget !== ''){
      newGoal.goalTarget = goalTarget
    }

    this.props.onCreate(newGoal);
    this.clearState();
  }

  renderCreateGoalForm(){
    const { category, userData } = this.props;
    const { goalName, goalDescription, goalTarget } = this.state;

    const goalType = this.goalType();

    return (
      <form className="velocity-form">
        <h2>Create new goal</h2>
        <div className="form-group">
          <div className="input-group half-width">
            <label htmlFor="velocity-goal-name">Name<br/><small>Give this goal a name</small></label>
              <input
                ref={input => { this.goalNameInput = input; }}
                id="velocity-goal-name"
                autoComplete="off"
                type="text"
                value={goalName || ''}
                onChange={e => {this.setState({ goalName: e.target.value })}}
              />
          </div>
          {this.goalType() === 'measure' &&
            <div className="input-group half-width">
              <label htmlFor="velocity-goal-target-amount">Target Amount<br/><small>Set a target amount for {userData.firstName}</small></label>
                <NumericalInput className="fs-block" formatThousands={true} value={goalTarget || ''} onUpdate={val => { this.setState({ goalTarget: val }) }} />
            </div>
          }
          {this.goalType() === 'forecast' &&
            <div className="input-group half-width">
              <label htmlFor="velocity-goal-target-amount">Forecast Amount<br/><small>Set a forecast target for {userData.firstName}</small></label>
                <NumericalInput className="fs-block" formatThousands={true} value={goalTarget || ''} onUpdate={val => { this.setState({ goalTarget: val }) }} />
            </div>
          }
        </div>
        <div className="form-group" style={{display: 'none'}}>
          <div className="input-group full-width">
            <label htmlFor="velocity-goal-description">Description<br/><small>What {userData.firstName} will see</small></label>
            <textarea
              id="velocity-goal-description"
              className="fs-block"
              value={goalDescription || ''}
              onChange={e => { this.setState({ goalDescription: e.target.value }) }}
            />
          </div>
        </div>
      </form>
    );
  }

  render(){

    if(!this.props.visible){
      return null;
    }

    return (
      <div className="modal">
        <div className="modal-container">
          <div className="close-icon" onClick={this.hide}>X</div>
          <div className="modal-content">
            {this.renderCreateGoalForm()}
          </div>
          <div className="modal-actions">
            <button onClick={this.createGoal} className="button primary">Create goal</button>
            <button onClick={this.hide} className="button grey-outline">Cancel</button>
          </div>
        </div>
      </div>
    )
  }
}

export default CustomGoalModal;



// WEBPACK FOOTER //
// ./src/components/modals/customGoal.js